import React from "react"
import styled from 'styled-components'
import { breakpoints, colors} from '../css-variables'

const Sidebar = ({className, children}) => {
  return (
    <aside className={className}>
      {children}
    </aside>
  )
}

const StyledSidebar = styled(Sidebar)
` 
  min-width:344px;
  /*border-top: 1px solid ${colors.rulesGrey};
  border-bottom: 1px solid ${colors.rulesGrey};*/
  @media screen and ${breakpoints.laptopS} {
    width: 368px;
    padding-left: 24px;
    border-top: none;
    border-bottom: none;
    border-left: 1px solid ${colors.mainRed};
  }
  h3{
    font-size: 20px;
    margin: 0 0 24px 0;
  }
` 
export default StyledSidebar